import useQuestionCategories from "../hooks/useQuestionCategories";
import { useNavigate } from "react-router-dom";
import CategoryModal from "../components/CategoryModal";
import "./SelectInterviewQuestionCategory.css";
import { useParams } from "react-router-dom";

export default function SelectInterviewQuestionCategory() {

    const navigate = useNavigate();
    const { domainId, packId, interviewId } = useParams();

    const {
        loading,
        sortedCategories,
        modalOpen,
        setModalOpen,
        editData,
        openCreateModal,
        openEditModal,
        deleteCategory,
        handleSave,
    } = useQuestionCategories(domainId);

    if (loading) return <h2 className="loading">Loading...</h2>;

    const handleViewAllQuestions = () => { 
        navigate(`/admin/domain/interview-questions/${domainId}/${packId}/${interviewId}`)
    }

    return (
        <div className="admin-page">

            {/* Header */}
            <div className="header">
                <h1>Select A Category</h1>
                <button onClick={() => { handleViewAllQuestions()}}>View All Questions</button>
            </div>
         
            {/* Category List */}
            <div className="category-grid">
                {sortedCategories.map((cat) => (
                    <div className="category-card"
                        key={cat.id}
                        onClick={() => navigate(`/admin/domain/${domainId}/${cat.id}/pack/${packId}/interview/${interviewId}`)}
                    >
                        <div className="info">
                            <h3>{cat.name}</h3>
                            <p className="desc">{cat.description}</p>
                            <span className="order">Order: {cat.orderId}</span>
                        </div>

                    </div>
                ))}
            </div>

            {modalOpen && (
                <CategoryModal
                    editData={editData}
                    onClose={() => setModalOpen(false)}
                    onSave={handleSave}
                />
            )}
        </div>
    );
}
